import React, { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { createUserWithEmailAndPassword } from 'firebase/auth'
import { setDoc, doc, serverTimestamp } from 'firebase/firestore'

import { auth, db } from '../firebase'
import Layout from '../components/layout'

function SignUp() {
  const navigate = useNavigate() // Navigation

  // For login form
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPass, setConfirmPass] = useState('')

  // Current user
  const user = auth.currentUser
  useEffect(() => {
    if (user) {
      navigate('/home')
    }
  }, [user, navigate])

  function createUser() {
    // Check passwords
    if (password !== confirmPass) {
      console.log('Passwords do not match!')
      return
    }

    // Create user
    createUserWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        console.log(userCredential.user.uid)
        setDoc(doc(db, 'Users', userCredential.user.uid), {
          name: name,
          email: email,
          admin: false,
          created_at: serverTimestamp()
        })
          .then(() => {
            console.log('Document has been added successfully')
            navigate('/home')
          })
          .catch((error) => {
            console.log(JSON.stringify(error))
          })
      })
      .catch((error) => {
        console.log(JSON.stringify(error))
      })
  }

  return (
    <Layout>
      <div className="container mx-auto flex max-w-sm flex-1 flex-col items-center justify-center px-2">
        <div className="w-full rounded bg-white px-6 py-8 text-black shadow-md">
          {/* Main header */}
          <h1 className="mb-8 text-center text-3xl">Sign up</h1>
          {/* Name text input */}
          <input
            type="text"
            className="border-grey-light mb-4 block w-full rounded border p-3"
            name="fullname"
            placeholder="Full Name"
            onChange={(event) => {
              setName(event.target.value)
            }}
          />

          {/* Email text input */}
          <input
            type="text"
            className="border-grey-light mb-4 block w-full rounded border p-3"
            name="email"
            placeholder="Email"
            onChange={(event) => {
              setEmail(event.target.value)
            }}
          />

          {/* Password text input */}
          <input
            type="password"
            className="border-grey-light mb-4 block w-full rounded border p-3"
            name="password"
            placeholder="Password"
            onChange={(event) => {
              setPassword(event.target.value)
            }}
          />

          {/* Password confirmation text input */}
          <input
            type="password"
            className="border-grey-light mb-4 block w-full rounded border p-3"
            name="confirm_password"
            placeholder="Confirm Password"
            onChange={(event) => {
              setConfirmPass(event.target.value)
            }}
          />

          {/* Create account button */}
          <button
            type="submit"
            onClick={() => {
              createUser()
            }}
            className="my-1 w-full rounded bg-primary py-3 text-center text-white hover:bg-red-600 focus:outline-none"
          >
            Create Account
          </button>

          {/* Terms of service text */}
          <div className="text-grey-dark mt-4 text-center text-sm">
            By signing up, you agree to the
            <a
              className="border-grey-dark ml-1 border-b text-primary no-underline"
              href="/"
            >
              Terms of Service
            </a>{' '}
            and
            <a
              className="border-grey-dark ml-1 border-b text-primary no-underline"
              href="/"
            >
              Privacy Policy
            </a>
          </div>
        </div>

        {/* Already have account bottom text */}
        <div className="text-grey-dark mt-6">
          Already have an account?
          <Link
            className="ml-1 border-b border-primary text-primary no-underline"
            to="/login"
          >
            Log in
          </Link>
          .
        </div>
      </div>
    </Layout>
  )
}

export default SignUp
